import { render } from "./Chapter5.vue?vue&type=template&id=59f528c4"
import script from "./Chapter5.vue?vue&type=script&lang=js"
export * from "./Chapter5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__